// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Tabs_tabs__2g0zO","border":"Tabs_border__px33X","tabNav":"Tabs_tabNav__yHFrn","tabHeader":"Tabs_tabHeader__2HYhR"};